import clsx from 'clsx'
import { visuallyHidden } from 'leds'
import React, { CSSProperties } from 'react'

import { Markdown } from '../Markdown/Markdown'
import { heading } from './Heading.css'

type HeadingProps = {
  label?: string | null | undefined
  headline: string | null | undefined
  description?: string | null | undefined
  size: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'
  level: 1 | 2 | 3 | '1' | '2' | '3'
  weight?: 'regular' | 'medium' | 'bold'
  noSpacing?: boolean
  skipWidth?: boolean
  style?: CSSProperties
}

function Heading({
  label,
  headline,
  description,
  size = 'm',
  weight = 'bold',
  style,
  level = 2,
  noSpacing,
  skipWidth,
}: HeadingProps) {
  const HeadlineTag = `h${level}` as keyof React.JSX.IntrinsicElements

  return (
    <div className={clsx(heading._, skipWidth ? null : heading.width)} style={style}>
      <div
        className={clsx(
          heading.label,
          label ? null : visuallyHidden,
          noSpacing ? heading.withoutSpacing : null
        )}
      >
        {label}
      </div>
      <HeadlineTag
        className={clsx(
          `${heading[size]}`,
          heading.weight[weight],
          noSpacing ? heading.withoutSpacing : heading.withSpacing
        )}
      >
        {headline}
      </HeadlineTag>
      {!!description && (
        <Markdown className={heading.description} markdown={description} skipWidth={skipWidth} />
      )}
    </div>
  )
}

export default Heading
